var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"mt-base",attrs:{"title":"Dispositivos de confianza."}},[_c('div',{staticClass:"flex flex-col gap-4"},_vm._l((_vm.devices),function(device){return _c('TrustedDevice',{attrs:{"device":device},on:{"on-device-deleted":_vm.fetchDevices}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }